import { createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d0e6652a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "serve-setting" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "s-form-title" }, "扫描设置", -1 /* HOISTED */))
const _hoisted_3 = { class: "scan" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "suffix" }, "ms", -1 /* HOISTED */))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "note form-note" }, " 扫描周期单位为秒,可使用*表达式.设置周期最短为10 ", -1 /* HOISTED */))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "note form-note" }, " 在扫描漫画的时候,自动解压缩zip,cbz,rar,pdf等压缩文件,当您需要获取封面的时候可考虑开启此选项. 无论何时请谨慎开启此项,他会大量占用cpu与内存资源,甚至会使任务队列卡死,尤其是您拥有大量pdf文件的时候. ", -1 /* HOISTED */))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "s-form-title" }, "ssl证书设置 ", -1 /* HOISTED */))
const _hoisted_8 = { class: "ssl" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "note form-note" }, " ssl证书在默认模式下,以http的方式监听443端口,使用http://smanga_domain:443可以访问. 你可以使用宿主机的nginx配置反向代理进行设置. 如果你在宿主机没有nginx或者不希望通过反代的方式进行配置,可以在此处填写证书使用的文件,smanga会将这些文件写入到nginx配置之中. ", -1 /* HOISTED */))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "s-form-title" }, "封面设置", -1 /* HOISTED */))
const _hoisted_11 = { class: "scan" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "suffix poster-suffix" }, "KB", -1 /* HOISTED */))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "note form-note" }, " 扫描周期单位为秒,可使用*表达式.设置周期最短为10 ", -1 /* HOISTED */))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "s-form-title" }, "压缩文件设置", -1 /* HOISTED */))
const _hoisted_15 = { class: "scan" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "suffix compress-suffix" }, "天", -1 /* HOISTED */))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "note form-note" }, " 文件保存周期单位为天,填写0不删除文件. ", -1 /* HOISTED */))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "s-form-title" }, "登录封面设置(每个客户端单独设置)", -1 /* HOISTED */))
const _hoisted_19 = { class: "back" }
const _hoisted_20 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_form, {
      model: $setup.form,
      "label-width": "10rem"
    }, {
      default: _withCtx(() => [
        _hoisted_2,
        _createCommentVNode(" 语言设置 "),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_el_form_item, { label: "扫描周期" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: $setup.form.interval,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.form.interval) = $event)),
                class: "interval"
              }, null, 8 /* PROPS */, ["modelValue"]),
              _hoisted_4,
              _createVNode(_component_el_button, {
                type: "primary",
                onClick: $setup.comfirm_interval
              }, {
                default: _withCtx(() => [
                  _createTextVNode("确定")
                ]),
                _: 1 /* STABLE */
              })
            ]),
            _: 1 /* STABLE */
          })
        ]),
        _hoisted_5,
        _createCommentVNode("自动解压"),
        _createVNode(_component_el_form_item, { label: "自动解压" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_switch, {
              class: "auto-compress",
              modelValue: $setup.form.autoCompress,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.form.autoCompress) = $event)),
              "active-value": '1',
              "inactive-value": '0'
            }, null, 8 /* PROPS */, ["modelValue"]),
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: $setup.comfirm_auto_compressl
            }, {
              default: _withCtx(() => [
                _createTextVNode("确定")
              ]),
              _: 1 /* STABLE */
            })
          ]),
          _: 1 /* STABLE */
        }),
        _hoisted_6,
        _hoisted_7,
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_el_form_item, { label: "pem文件" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: $setup.form.pem,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.form.pem) = $event)),
                class: "pem"
              }, null, 8 /* PROPS */, ["modelValue"])
            ]),
            _: 1 /* STABLE */
          }),
          _createVNode(_component_el_form_item, { label: "key文件" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: $setup.form.key,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.form.key) = $event)),
                class: "key"
              }, null, 8 /* PROPS */, ["modelValue"])
            ]),
            _: 1 /* STABLE */
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: $setup.comfirm_ssl
          }, {
            default: _withCtx(() => [
              _createTextVNode("确定")
            ]),
            _: 1 /* STABLE */
          }),
          _createVNode(_component_el_button, {
            type: "success",
            onClick: $setup.reset_ssl
          }, {
            default: _withCtx(() => [
              _createTextVNode("重置ssl证书设置")
            ]),
            _: 1 /* STABLE */
          }),
          _hoisted_9
        ]),
        _hoisted_10,
        _createCommentVNode(" 语言设置 "),
        _createElementVNode("div", _hoisted_11, [
          _createVNode(_component_el_form_item, { label: "压缩大小" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: $setup.form.posterSize,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.form.posterSize) = $event)),
                class: "poster-size"
              }, null, 8 /* PROPS */, ["modelValue"]),
              _hoisted_12,
              _createVNode(_component_el_button, {
                type: "primary",
                onClick: $setup.confirm_poster_size
              }, {
                default: _withCtx(() => [
                  _createTextVNode("确定")
                ]),
                _: 1 /* STABLE */
              })
            ]),
            _: 1 /* STABLE */
          })
        ]),
        _hoisted_13,
        _hoisted_14,
        _createCommentVNode(" 语言设置 "),
        _createElementVNode("div", _hoisted_15, [
          _createVNode(_component_el_form_item, { label: "文件保存时长" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: $setup.form.saveDuration,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($setup.form.saveDuration) = $event)),
                class: "compress-time"
              }, null, 8 /* PROPS */, ["modelValue"]),
              _hoisted_16,
              _createVNode(_component_el_button, {
                type: "primary",
                onClick: $setup.confirm_compress_duration
              }, {
                default: _withCtx(() => [
                  _createTextVNode("确定")
                ]),
                _: 1 /* STABLE */
              })
            ]),
            _: 1 /* STABLE */
          })
        ]),
        _hoisted_17,
        _hoisted_18,
        _createCommentVNode("自动解压"),
        _createVNode(_component_el_form_item, { label: "封面随机" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_switch, {
              class: "auto-compress",
              modelValue: $setup.backRandom,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (($setup.backRandom) = $event)),
              onChange: $setup.back_random
            }, null, 8 /* PROPS */, ["modelValue"]),
            _createCommentVNode(" <el-button type=\"primary\" @click=\"comfirm_auto_compressl\">确定</el-button> ")
          ]),
          _: 1 /* STABLE */
        }),
        _createElementVNode("div", _hoisted_19, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList($setup.coverArr, (item) => {
            return _createElementVNode("div", {
              key: item,
              class: _normalizeClass(['back-item', 'bg' + item, { 'active': $setup.activeBack === item }]),
              onClick: ($event: any) => ($setup.back_click(item))
            }, null, 10 /* CLASS, PROPS */, _hoisted_20)
          }), 64 /* STABLE_FRAGMENT */))
        ])
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["model"])
  ]))
}